export const version = '1.3.0';
export const navbarBreakPoint = 'xl';
